import classNames from 'classnames/bind';
import React, { memo } from 'react';
import { Button } from '@carnica/ui-kit';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var StoreButton = /*#__PURE__*/memo(function (_ref) {
  var _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {
      return false;
    } : _ref$onClick,
    variant = _ref.variant,
    href = _ref.href,
    icon = _ref.icon;
  return /*#__PURE__*/React.createElement(Button, {
    className: cn('store-button', {
      'store-button--appStore': variant === 'appStore'
    }),
    href: href,
    mode: "inline",
    onClick: onClick,
    tagName: "a"
  }, /*#__PURE__*/React.createElement("img", {
    alt: variant,
    className: cn('store-button__img'),
    loading: "lazy",
    src: icon
  }));
});